import { render, staticRenderFns } from "./SecurityView.vue?vue&type=template&id=365ef6f4&scoped=true&lang=pug&"
import script from "./SecurityView.vue?vue&type=script&lang=js&"
export * from "./SecurityView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365ef6f4",
  null
  
)

export default component.exports